module.exports = __webpack_public_path__ + "img/pumping-activities-role8.3dd0b820.png";